import React, { ReactElement, ReactNode, createContext } from "react"

import { LCTOnlyDatasets } from "../../../../../../constants/enums"
import { AppError } from "../../../../../../errors/errorProcessors"
import { IDeviceFormContextValue } from "../../../../types/providerTypes"
import CreateHpDeviceProvider from "../../../hp/providers/baseProviders/createHpDeviceProvider"
import { HpDeviceFormData } from "../../../types/providerTypes"

type CreateAcuDeviceProviderProps = {
    formData: HpDeviceFormData
    setFormData: React.Dispatch<React.SetStateAction<HpDeviceFormData>>
    formDataIsLoading: boolean
    formDataError?: AppError
    systemReference?: string
    attachmentUUID?: string
    canEditManufacturer: boolean
    children: ReactNode
}

export const CreateAcuDeviceContext = createContext(
    {} as IDeviceFormContextValue<HpDeviceFormData>
)

/**
 * Thin wrapper around CreateHpDeviceProvider — delegates all logic,
 * only overrides the dataset (ACU) and context.
 */
const CreateAcuDeviceProvider = ({
    formData,
    setFormData,
    formDataIsLoading,
    formDataError,
    systemReference,
    attachmentUUID,
    canEditManufacturer,
    children,
}: CreateAcuDeviceProviderProps): ReactElement => (
    <CreateHpDeviceProvider
        formData={formData}
        setFormData={setFormData}
        formDataIsLoading={formDataIsLoading}
        formDataError={formDataError}
        systemReference={systemReference}
        attachmentUUID={attachmentUUID}
        canEditManufacturer={canEditManufacturer}
        dataset={LCTOnlyDatasets.ACU}
        deviceContext={CreateAcuDeviceContext}
    >
        {children}
    </CreateHpDeviceProvider>
)

CreateAcuDeviceProvider.defaultProps = {
    formDataError: undefined,
    attachmentUUID: undefined,
    systemReference: undefined,
}

export default CreateAcuDeviceProvider
